<template>
  <div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="justify-center">
          <v-avatar>
            <img src="/all-assets/common/logo/cpb/cpbit.png" alt="CPB-IT" />
          </v-avatar>CPB-IT Portal Register
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <form @submit.prevent="storeData()">
              <v-row>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User AD ID"
                    placeholder="Enter user AD Login ID"
                    :rules="[(v) => !!v || 'AD ID is required!']"
                    v-model="form.login"
                    :error-messages="form.errors.get('login')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Name"
                    placeholder="Enter User Name"
                    :rules="[(v) => !!v || 'User Name is required!']"
                    v-model="form.name"
                    :error-messages="form.errors.get('name')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Business Unit"
                    placeholder="Enter User Business Unit"
                    :rules="[(v) => !!v || 'Business Unit is required!']"
                    v-model="form.business_unit"
                    :error-messages="form.errors.get('business_unit')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Location"
                    placeholder="Enter User Location"
                    :rules="[(v) => !!v || 'Location is required!']"
                    v-model="form.location"
                    :error-messages="form.errors.get('location')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Department"
                    placeholder="Enter User Department"
                    :rules="[(v) => !!v || 'Department is required!']"
                    v-model="form.department"
                    :error-messages="form.errors.get('department')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User position"
                    placeholder="Enter User Position"
                    :rules="[(v) => !!v || 'Position is required!']"
                    v-model="form.position"
                    :error-messages="form.errors.get('position')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Office ID"
                    placeholder="Enter User Office ID"
                    v-model="form.office_id"
                    :error-messages="form.errors.get('office_id')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Office Contact"
                    placeholder="Enter User Office Contact"
                    v-model="form.office_contact"
                    :error-messages="form.errors.get('office_contact')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="email"
                    label="User Office Email"
                    placeholder="Enter User Office Email"
                    :rules="[(v) => /.+@.+/.test(v) || 'E-mail must be valid']"
                    v-model="form.office_email"
                    :error-messages="form.errors.get('office_email')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="text"
                    label="User Personal Contact"
                    placeholder="Enter User Personal Contact"
                    v-model="form.personal_contact"
                    :error-messages="form.errors.get('personal_contact')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    type="email"
                    label="User Personal Email"
                    placeholder="Enter User Personal Email"
                    :rules="[(v) => /.+@.+/.test(v) || 'E-mail must be valid']"
                    v-model="form.personal_email"
                    :error-messages="form.errors.get('personal_email')"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" lg="3">
                  <v-text-field label="Manager Name" v-model="form.manager_name" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field label="Manager Email" v-model="form.manager_email" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field label="B.U. Name" v-model="form.bu_name" readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field label="B.U. Email" v-model="form.bu_email" readonly></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    type="text"
                    label="Purpose of Access"
                    :rules="[v => !!v || 'Purpose of Access is required!']"
                    v-model="form.remarks"
                    :error-messages="form.errors.get('remarks')"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-file-input
                    :rules="imageRules"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Pick an image"
                    prepend-icon="mdi-camera"
                    label="Choose Image"
                    @change="onFileChange"
                    :error-messages="form.errors.get('image')"
                    required
                  ></v-file-input>
                </v-col>

                <v-col cols="12" md="4">
                  <v-img
                    :src="imageUrl"
                    class="rounded rounded-circle"
                    height="100px"
                    width="100px"
                    alt="Image"
                  />
                </v-col>
              </v-row>

              <v-btn block blockdepressed :loading="loading" color="primary mt-3" type="submit">
                <v-icon left dark>mdi-cloud-upload</v-icon>Submit
              </v-btn>
            </form>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from "vform";
export default {
  props: ["adData"],

  data() {
    return {
      valid: false,
      dialog: true,
      imageUrl: "",

      loading: false,
      dataObj: this.adData,

      form: new Form({
        login: "",
        name: "",
        image: "",
        office_contact: "",
        personal_contact: "",
        office_email: "",
        personal_email: "",
        office: "",
        business_unit: "",
        office_id: "",
        department: "",
        position: "",
        nid: "",

        manager_name: "",
        manager_email: "",
        bu_name: "",
        bu_email: "",

        remarks: ""
      }),

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      imageRules: [
        v => !!v || "Image is required",
        v => !v || v.size < 2000000 || "Avatar size should be less than 2 MB!"
      ]
    };
  },
  methods: {
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageUrl = e.target.result;
        this.form.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {
        return;
      }
      this.createImage(file);
    },

    //storeData
    storeData() {
      this.loading = true;

      // request send and get response
      this.form
        .post("/register_store")
        .then(response => {
          console.log(response.data);
          this.loading = true;
          this.dialog = false;
          Swal.fire({
            icon: response.data.icon,
            title: response.data.msg
          }).then(function() {
            // After click ok then redirect
            window.location.href = "/login";
            //this.$router.push({ name: "Login" });
          });
        })
        .catch(error => {
          this.loading = false;
          Swal.fire({
            icon: response.data.icon,
            title: "Something is going wrong! Try again later",
            customClass: "text-danger"
          }).then(function() {
            // After click ok then redirect
            window.location.href = "/login";
          });
          console.log(error);
        });
    }

    //   console.log(response.data);
    //   // Input field make empty
    //   this.form.reset();
    //   this.form.errors.clear();

    //   this.loading = false;
    //   this.dialog = false;

    //   if (response.data.status == "success") {
    //     if (response.data.code == 200) {
    //       Swal.fire({
    //         icon: response.data.icon,
    //         title: response.data.msg
    //       }).then(function() {
    //         // After click ok then redirect
    //         window.location.href = "/login";
    //         //this.$router.push({ name: "Login" });
    //       });
    //     }
    //   } else {
    //     this.registerFrmShow = false;
    //     this.adData = "";
    //     // swal alert
    //     Swal.fire({
    //       icon: response.data.icon,
    //       title: "Sorry!!<br><small>" + response.data.msg + "</small>",
    //       customClass: "text-danger"
    //     });
    //     // Swal.fire("Failed!", data.message, "warning");
    //     console.log(response.data);
    //   }
    // }
  },

  mounted() {
    this.form.login = this.dataObj.data.UserID;
    this.form.name = this.dataObj.data.UserName;
    this.form.department = this.dataObj.data.Department;
    this.form.office_id = this.dataObj.data.OfficeID;
    this.form.office_contact = this.dataObj.data.OfficeMobile;
    this.form.personal_contact = this.dataObj.data.PersonalMobile;
    this.form.office_email = this.dataObj.data.OfficeEmail;
    this.form.personal_email = this.dataObj.data.PersonalEmail;
    this.form.location = this.dataObj.data.Office;
    this.form.business_unit = this.dataObj.data.BusinessUnit;
    this.form.nid = this.dataObj.data.NationalID;
    this.form.position = this.dataObj.data.Position;

    this.form.manager_name = this.dataObj.manager.name;
    this.form.manager_email = this.dataObj.manager.office_email;
    this.form.bu_name = this.dataObj.bu.name;
    this.form.bu_email = this.dataObj.bu.office_email;
  },

  created() {
    console.log("addd data", this.dataObj);
  }
};
</script>
